import styled from "@emotion/styled"
import { Tab, Tabs } from "@mui/material"
import {
  ScrollingProvider,
  Section,
  useScrollSections,
} from "common/ScrollSection"
import { MOBILE_HEIGHT } from "layout/Header/HeaderStyled"

export { ScrollingProvider, Section }

const MENU_HEIGHT = 41
export const STICKY_OFFSET = -(MOBILE_HEIGHT + MENU_HEIGHT)

const Styled = {
  StaticMenu: styled(Tabs)`
    position: sticky;
    top: ${MOBILE_HEIGHT}px;
    background: ${(p) => p.theme.colors.white};
    box-shadow: 0 10px 20px 0 ${(p) => p.theme.colors.darkIndigo};
    z-index: 1000;
    min-height: ${MENU_HEIGHT}px;
    justify-content: center;

    .Mui-selected .MuiTab-wrapper {
      color: ${(p) => p.theme.colors.marine};
    }

    .MuiTab-root {
      min-height: ${MENU_HEIGHT}px;
    }

    .MuiTab-wrapper {
      font-weight: bold;
      font-size: 12px;
    }
  `,
  Tab: styled(Tab)`
    padding: 6px 14px;
    &:first-child {
      padding-right: 24px;
    }
  `,
}

export interface StaticMenuSection {
  id: string
  title: string
}

const StaticMenu = () => {
  const { selected, sections } = useScrollSections()
  return (
    <Styled.StaticMenu value={selected} variant="scrollable">
      {sections.map((item, i) => (
        <Styled.Tab
          key={i}
          onClick={() => item.onClick()}
          label={item.title}
          value={item.id}
        />
      ))}
    </Styled.StaticMenu>
  )
}

export default StaticMenu
